<template lang="pug">
div(id="print-area")
    div(id="print-content")
      ApplicationDocument(:intakeAssessment="intakeAssessment" :client="client")
</template>

<script>
import ApplicationDocument from '@/components/intake_assessment/applicationDoc.vue';


export default {
    name: 'PrintIntake',
    components: {
      ApplicationDocument
    },
    props: {
        intakeAssessment: {
            type: Object,
            required: true
        },
        client: {
            type: Object,
            required: true
        }
    },
    data(){
        return{
          
        }
    },
    
    mounted() {
      
    },
    methods: {
      
    }
}
</script>

<style>
#print-area, .print-hide {
  display: inline;
}
.print-show, .print-show-plain {
  display: none;
}
@page {
  size: A4;
}
@media print {
  * { overflow: visible !important; }
  
  #app,#print-area,#print-content {
    display: block !important;
  }
  
  body *, .print-hide {
    visibility: hidden;
  }
  #print-area, #print-area *, .print-show, .print-show-plain {
    visibility: visible;
  }
  .print-show {
    display: block;
    white-space: pre-wrap;
    min-width: 100%;
    min-height: 2em;
  }
  .print-show-plain {
    display: block;
    white-space: pre-wrap;
  }
  .print-hide {
    display: none;
  }
  #print-area {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    
  }
  #print-content {
    display: block;
    word-wrap: break-word;
    max-width: 210mm;
    min-height: 297mm;
  }
  .break-before {
    break-before: page !important;
    page-break-before: always !important;
    display: block !important;
    position: relative;
  }
}
</style>